import "./dashboard-sections.css";
import DashboardCard from "./DashboardCard";

const MetricBox = ({ label, value, unit }) => (
  <div className="db-evap-box">
    <div className="db-evap-label">{label}</div>
    <div className="db-evap-value neutral">
      {value ?? "—"}{unit && <span className="db-metric-unit"> {unit}</span>}
    </div>
  </div>
);

const ProcessingOverview = ({ data = {}, isLoading = false }) => (
  <div className="po-wrapper">

    {/* CASES — full width */}
    <DashboardCard title="Cases">
      <div className="db-evap-row">
        <MetricBox label="CASES ENTERED"    value={data?.cases_entered ?? 180}    />
        <MetricBox label="TOTAL CASES USED (ACCEPTED)" value={data?.total_cases_used ?? 60} />
        <MetricBox label="CASES PROCESSED"  value={data?.cases_processed ?? 360}  />
        <MetricBox label="CASES COMBINED"   value={data?.cases_combined ?? 120}   />
        <MetricBox label="PEELERS"          value={data?.peelers ?? 45}          />
      </div>
    </DashboardCard>

    {/* Bottom row */}
    <div className="po-bottom-row-3">

      {/* Left: Treys & Carts */}
      <DashboardCard title="Treys &amp; Carts">
        <div className="po-treys-grid">
          <MetricBox label="TREYS STRIPS" value={data?.treys_strips ?? 500} />
          <MetricBox label="TREYS CHEEKS" value={data?.treys_cheeks ?? 850} />
          <MetricBox label="TREYS TAPITA" value={data?.treys_cheeks ?? 850} />
          <MetricBox label="TOTAL TREYS"  value={data?.total_treys ?? 350}  />
          <MetricBox label="CARTS"        value={data?.carts ?? 50}        />
        </div>
      </DashboardCard>

      {/* Right: KG Taken Off + Trash — separate cards stacked vertically */}
      <div className="po-right-col">
        <DashboardCard
          title="KG Taken Off"
          icon={<span className="po-total-kg-badge">Total: {data?.total_kg ?? "2000"} kg</span>}
        >
          <div className="db-avg-row">
            <span>Strip Total</span>
            <span className="db-avg-val">{data?.strip_total ?? "500"} <span className="db-metric-unit">kg</span></span>
          </div>
          <div className="db-avg-row">
            <span>Cheek Total</span>
            <span className="db-avg-val">{data?.cheek_total ?? "700"} <span className="db-metric-unit">kg</span></span>
          </div>
          <div className="db-avg-row">
            <span>Tapita Total</span>
            <span className="db-avg-val">{data?.tapita_total ?? "800"} <span className="db-metric-unit">kg</span></span>
          </div>
        </DashboardCard>

        <DashboardCard title="Trash">
          <div className="db-avg-row">
            <span>Trash (Sorting)</span>
            <span className="db-avg-val">{data?.trash_sorting ?? "50"} <span className="db-metric-unit">kg</span></span>
          </div>
          <div className="db-avg-row">
            <span>Trash (Processing)</span>
            <span className="db-avg-val">{data?.trash_processing ?? "40"} <span className="db-metric-unit">kg</span></span>
          </div>
        </DashboardCard>
      </div>

    </div>
  </div>
);

export default ProcessingOverview;
